import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';
import { 
  IoLogoFacebook, 
  IoLogoInstagram, 
  IoLogoYoutube, 
  IoLocationOutline, 
  IoCallOutline, 
  IoMailOutline, 
  IoArrowForward
} from 'react-icons/io5';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      {/* --- MAIN FOOTER CONTENT --- */}
      <div className={styles.mainFooter}>
        <div className={styles.container}>
          
          {/* CỘT 1: THƯƠNG HIỆU */}
          <div className={styles.col}>
            <h3 className={styles.logo}>Hương Trầm Cổ Mộc</h3>
            <p className={styles.desc}>
              Tinh hoa đất trời, gửi trọn an yên. Chúng tôi cam kết mang đến những sản phẩm trầm hương tự nhiên, giúp thanh lọc không gian và cân bằng cảm xúc.
            </p>
            <div className={styles.contactInfo}>
              <p><IoLocationOutline />Ngõ 11, Thôn Mai Châu, Xã Thiên Lộc, Thành phố Hà Nội, Việt Nam</p>
              
              {/* SỬA PHẦN NÀY: Clickable Phone */}
              <p>
                <a href="tel:0964472868" style={{display:'flex', alignItems:'center', gap:'8px', color:'inherit', textDecoration:'none'}}>
                  <IoCallOutline /> 0964 472 868
                </a>
              </p>
              
              {/* SỬA PHẦN NÀY: Clickable Email */}
              <p>
                <a href="mailto:dungnhu@huongtramcomoc.vn" style={{display:'flex', alignItems:'center', gap:'8px', color:'inherit', textDecoration:'none'}}>
                  <IoMailOutline /> dungnhu@huongtramcomoc.vn
                </a>
              </p>
            </div>
          </div>

          {/* CỘT 2: VỀ CHÚNG TÔI */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Về Chúng Tôi</h4>
            <ul className={styles.footerLinks}>
              <li><Link to="/gioi-thieu">Câu Chuyện Thương Hiệu</Link></li>
              <li><Link to="/vung-nguyen-lieu">Vùng Nguyên Liệu</Link></li>
              <li><Link to="/kienthuc">Kiến Thức Trầm Hương</Link></li>
              <li><Link to="/lien-he">Liên Hệ Hợp Tác</Link></li>
            </ul>
          </div>

          {/* CỘT 3: CHÍNH SÁCH */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Hỗ Trợ Khách Hàng</h4>
            <ul className={styles.footerLinks}>
              <li><Link to="/tra-cuu-don-hang">Tra Cứu Đơn Hàng</Link></li>
              <li><Link to="/chinh-sach-doi-tra">Chính Sách Đổi Trả</Link></li>
              <li><Link to="/chinh-sach-bao-mat">Chính Sách Bảo Mật</Link></li>
              <li><Link to="/huong-dan-mua-hang">Hướng Dẫn Mua Hàng</Link></li>
            </ul>
          </div>

          {/* CỘT 4: ĐĂNG KÝ NHẬN KHUYẾN MÃI (MỚI) */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Tri ân khách hàng</h4>
            {/* <p className={styles.newsletterDesc}>
              Nhập email để nhận ngay các phần quà giảm giá cho đơn hàng đầu tiên và các ưu đãi độc quyền.
            </p> */}
            <form className={styles.newsletterForm}>
              <input type="email" placeholder="Địa chỉ email của bạn..." required />
              <button type="submit">
                <IoArrowForward />
              </button>
            </form>

            <div className={styles.socialWrapper}>
              <span>Kết nối với chúng tôi:</span>
              <div className={styles.socialIcons}>
                <a href="#" aria-label="Facebook"><IoLogoFacebook /></a>
                <a href="#" aria-label="Instagram"><IoLogoInstagram /></a>
                <a href="#" aria-label="Youtube"><IoLogoYoutube /></a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* --- BOTTOM BAR (COPYRIGHT & PAYMENT) --- */}
      <div className={styles.bottomBar}>
        <div className={styles.container}>
          <div className={styles.bottomContent}>
            <p className={styles.copyright}>
              © {new Date().getFullYear()} <strong>Hương trầm cổ mộc</strong>. All rights reserved.
            </p>
            
            {/* Phương thức thanh toán chuyển xuống đây */}
            {/* <div className={styles.paymentMethods}>
                <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" />
                <img src="https://upload.wikimedia.org/wikipedia/vi/f/fe/MoMo_Logo.png" alt="Momo" />
                <span className={styles.codBadge}>COD</span>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;